export enum ReportFormat {
    PNG = 0,
    PDF
}